import { Button, Icon } from "../../..";
import { getLink } from "../../utils";
import React from 'react';
import "./index.less";
var LoginPop = function LoginPop(props) {
  var _loginInfo$children;
  var _props$loginInfo = props.loginInfo,
    loginInfo = _props$loginInfo === void 0 ? {} : _props$loginInfo,
    Logout = props.Logout,
    logoutText = props.logoutText,
    originUrl = props.originUrl,
    _onClick = props.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-header-loginPop"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "iron-header-loginPop-list "
  }, loginInfo && ((_loginInfo$children = loginInfo.children) === null || _loginInfo$children === void 0 ? void 0 : _loginInfo$children.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.value,
      className: "iron-header-loginPop-item ".concat((item === null || item === void 0 ? void 0 : item.className) && (item === null || item === void 0 ? void 0 : item.className)),
      onClick: function onClick() {
        if (_onClick && item !== null && item !== void 0 && item.disabledDefaultA) {
          //自定义点击事件
          _onClick(item);
        } else if (!(item !== null && item !== void 0 && item.disabledDefaultA)) {
          //默认跳转
          window.open(getLink(item === null || item === void 0 ? void 0 : item.href, originUrl), item === null || item === void 0 ? void 0 : item.target);
        }
      },
      id: "li-".concat(item === null || item === void 0 ? void 0 : item.id)
    }, /*#__PURE__*/React.createElement("a", null, item.label), (item === null || item === void 0 ? void 0 : item.logout) && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick(e) {
        e.stopPropagation();
        if (Logout) Logout();
      },
      size: "small",
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "door-out",
        className: "loginIcon"
      })
    }, logoutText));
  }))));
};
export default LoginPop;